







































































































































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import FileUpload from "vue-upload-component";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useUtilityStore } from "@/admin/store/utility";

@Component({
  components: {
    FileUpload,
    GenericLoadingSpinner
  }
})
export default class OmnibusTransactionCodeManagement extends Vue {
  $validator: Validator;
  file = null;
  isSubmitting = false;

  utilityStore = useUtilityStore();

  get submitDisabled () {
    return this.isSubmitting || this.utilityStore.isTransactionCodeFileProcessing;
  }

  fileChange (file) {
    if (!file) return;
    this.file = (document.getElementById("file-asset") as any).files[0];
  }

  get fileNameDisplay (): string {
    return this.file ? this.file.name : "Click to select .csv file";
  }

  submit () {
    if (!this.file) return;
    if (this.isSubmitting) return;

    this.isSubmitting = true;

    this.utilityStore.uploadTransactionCodeFile({
      file: this.file
    })
    .then(() => {
      this.utilityStore.uploadTransactionCodeFile();
    }).catch(() => null)
    .finally(() => {
      this.isSubmitting = false;
      this.file = null;
    });
  }
}
